import { render, staticRenderFns } from "./alphabeticalOrder.vue?vue&type=template&id=06a1e00e"
import script from "./alphabeticalOrder.vue?vue&type=script&lang=js"
export * from "./alphabeticalOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports